<template>
  <nav class="fixed bottom-0 w-full max-w-[800px] z-50 bg-white/95 backdrop-blur-xl rounded-t-[32px] border-t border-slate-100/90 shadow-[0_-12px_32px_rgba(0,0,0,0.06)] pb-safe">
    <div class="relative pt-2 pb-1">
      <ul class="grid grid-flow-col grid-cols-5 justify-between">
        <NavLink v-for="(nav, index) in navbar" 
          :key="index" 
          :to="{ name: nav.name }" 
          :icon="nav.icon" 
          :label="nav.label" 
          :custom-class="nav.customClass" 
          :notif="nav.notif"
          :newTab="nav.newTab"
        />
      </ul>
      <!-- Modern Floating Capsule Indicator -->
      <div 
        v-if="currentIndex !== null && currentIndex >= 0"
        class="nav-indicator-pill"
        :style="{ left: `calc(${currentIndex * 20}% + 10%)` }"
      ></div>
    </div>
  </nav>
</template>

<script>
import { useRoute } from 'vue-router';
import { ref, onMounted, watch, computed } from 'vue';
import NavLink from './NavLink.vue';

export default {
  name: 'NavBar',
  components: { NavLink },
  setup() {
    const currentIndex = ref(null);
    const route = useRoute();

    // Daftar menu navigasi dengan nilai notif dipastikan sebagai angka
    const navbar = computed(() => [
      { name: 'Home', icon: ['fas', 'house'], label: 'Home', notif: 0, newTab: false },
      { name: 'Publication', icon: ['fas', 'newspaper'], label: 'News', notif: 0, newTab: false },
      { name: 'QRCodeScanner', icon: ['fas', 'qrcode'], label: 'Pay', customClass: 'QR', notif: 0, newTab: false },
      { name: 'Academic', icon: ['fas', 'graduation-cap'], label: 'Edu', notif: 0, newTab: false },
      { name: 'Profile', icon: ['fas', 'user'], label: 'Profile', notif: 0, newTab: false},
    ]);

    // Cek indeks halaman aktif di navbar (termasuk sub-route)
    const checkIndex = () => {
      const currentName = String(route.name || '');
      const currentPath = String(route.path || '');

      const foundIndex = navbar.value.findIndex(item => {
        if (item.name === currentName) return true;
        if (item.name === 'Home' && (currentName === 'Home' || currentPath === '/home')) return true;
        if (item.name === 'Publication' && (currentName.startsWith('Publication') || currentPath.startsWith('/publication'))) return true;
        if (item.name === 'Academic' && (currentName.startsWith('Academic') || currentPath.startsWith('/academic'))) return true;
        if (item.name === 'Profile' && (currentName.startsWith('Profile') || currentPath.startsWith('/profile'))) return true;
        return false;
      });

      currentIndex.value = foundIndex;
    };

    onMounted(() => {
      checkIndex();
    });

    // Pantau perubahan route name maupun path
    watch(() => route.name, checkIndex);
    watch(() => route.path, checkIndex);

    return {
      navbar,
      currentIndex,
    };
  },
};
</script>

<style scoped>
.nav-indicator-pill {
  position: absolute;
  top: 0;
  height: 3.5px;
  width: 38px;
  border-radius: 9999px;
  background-color: var(--primary-color, #005bbf);
  transform: translateX(-50%);
  pointer-events: none;
  box-shadow: 0 2px 8px rgba(0, 91, 191, 0.35);
  transition: left 0.32s cubic-bezier(0.34, 1.56, 0.64, 1);
  will-change: left;
}
</style>
